export interface QueueProps<T> {
  _store: any[];
  push: (val: T) => T;
  shift: () => T;
  dequeue: () => T;
}
export class Queue<T> {
  _store: T[] = [];
  push(val: T) {
    this._store.push(val);
  }
  shift(): T | undefined {
    return this._store.shift();
  }
  dequeue(): T | undefined {
    return this._store[0];
  }
}
